import styled, { keyframes, css } from 'styled-components';
import { pxToRem } from '../v2/foundation/spacing/utils.js';
import { themeGetColor } from '../v2/foundation/theme/themeGet/get.js';

var overlayFadeIn = keyframes(["  from{background-color:transparent;backdrop-filter:blur(", ") opacity(0);}to{background-color:", ";backdrop-filter:blur(", ") opacity(1);}"], pxToRem(1.5), themeGetColor('gray.50', 0.24), pxToRem(1.5));
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-3ub8d3-0"
})(["overflow-y:auto;position:fixed;top:0;right:0;bottom:0;left:0;width:100vw;height:100vh;height:-webkit-fill-available;", ";"], function (props) {
  return props.$overlay && css(["animation:0.2s ", " forwards;"], overlayFadeIn);
});

export { Container };
